import Cookies from "cookies-js";
import {addMinutes} from "date-fns";

function parseJwt(token) {
    if (token === undefined || token === null) return undefined;
    return JSON.parse(window.atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
}

class currentUser {

    constructor() {
        this.cookieAccessToken = "zsdigp!8sdgouisgjkhgwr9sugh";
        this.cookieRefreshToken = "nmvyyiugfy9883ysgydgyqg-(2jfjhgjyhs";
        this.cookieUserId = "kGDL8076tsgdh20987ybuhfkho9esytguisdgkh";
        this.cookieTokenExpirationDate = "BNmx02ikl.,gkspoiugoisdygiyweiukghg";
        this.cookieCurrentCustomerId = "xldfgas8g478twgis<>us8dgp7souigya7og6yiwrusg";
    }

    isValid() {
        return Cookies.get(this.cookieAccessToken) !== undefined;
    }

    get accessToken() {
        return Cookies.get(this.cookieAccessToken);
    }

    get refreshToken() {
        return Cookies.get(this.cookieRefreshToken);
    }

    get userId() {
        return Cookies.get(this.cookieUserId);
    }

    get tokenExpirationDate() {
        return Cookies.get(this.cookieTokenExpirationDate);
    }

    get currentCustomerId () {
        return Cookies.get(this.cookieCurrentCustomerId);
    }

    set currentCustomerId(value) {
        const expirationDate = {expires: (60 + 5) * 60 };
        Cookies.set(this.cookieCurrentCustomerId, value, expirationDate);
    }

    get fullName() {
        const token = parseJwt(this.accessToken);
        return !token ? '' : token.Name;
    }
    get firstName() {
        const fullName = this.fullName;
        return fullName.split(' ')[0];
    }
    get lastName() {
        const fullName = this.fullName;
        return fullName.split(' ').pop();
    }
    get initials() {
        const first = this.firstName;
        const last = this.lastName;
        return `${first.substring(0,1)}${last.substring(0,1)}`.toUpperCase();
    }

    setTokenInfo(accessToken, refreshToken, userId, refreshTokenExpirationMinutes) {
        if (refreshTokenExpirationMinutes === undefined
            || refreshTokenExpirationMinutes === null
            || refreshTokenExpirationMinutes < 0) {
            refreshTokenExpirationMinutes = 59;
        }

        const expirationDate = {expires: (refreshTokenExpirationMinutes + 5) * 60 };

        Cookies.set(this.cookieAccessToken, accessToken, expirationDate);
        Cookies.set(this.cookieRefreshToken, refreshToken, expirationDate);
        Cookies.set(this.cookieUserId, userId, expirationDate);
        Cookies.set(this.cookieTokenExpirationDate, addMinutes(new Date(), refreshTokenExpirationMinutes).toISOString(), expirationDate);
    }

    logout() {
        Cookies.expire(this.cookieAccessToken);
        Cookies.expire(this.cookieRefreshToken);
        Cookies.expire(this.cookieUserId);
        Cookies.expire(this.cookieTokenExpirationDate);
        Cookies.expire(this.cookieCurrentCustomerId);
    }
}

export let CurrentUser = new currentUser();
